import ArroganceIcon from './icons/smile-arrogance.png';
import ClinginessIcon from './icons/smile-clinginess.png';
import DishonestyIcon from './icons/smile-dishonesty.png';
import ExcessiveDrammaIcon from './icons/smile-excessive_dramma.png';
import JealousyIcon from './icons/smile-jealousy.png';
import LackOfHumorIcon from './icons/smile-lack_of_humor.png';
import { MajorTurnOffOptionsType } from './types';

export const MAJOR_TURN_OFF_OPTIONS: MajorTurnOffOptionsType = [
  {
    id: 'arrogance',
    title: 'Arrogance',
    subtitle: 'Self-importance',
    icon: ArroganceIcon,
  },
  {
    id: 'excessive_dramma',
    title: 'Excessive drama',
    subtitle: 'Overreaction',
    icon: ExcessiveDrammaIcon,
  },
  {
    id: 'lack_of_humor',
    title: 'Lack of humor',
    subtitle: 'Too serious',
    icon: LackOfHumorIcon,
  },
  {
    id: 'clinginess',
    title: 'Clinginess',
    subtitle: 'Need for attention',
    icon: ClinginessIcon,
  },
  {
    id: 'dishonesty',
    title: 'Dishonesty',
    subtitle: 'Being untruthful',
    icon: DishonestyIcon,
  },
  {
    id: 'jealousy',
    title: 'Jealousy',
    subtitle: 'Feeling of insecurity',
    icon: JealousyIcon,
  },
];
